import React from 'react';

interface PlanBadgeProps {
    name: string;
    isActive?: string;
    color?: string;
    isTrial?: boolean;
    isPastDue?: string;
    trialLabel?: string;
}

const SubscriptionPlanBadge: React.FC<PlanBadgeProps> = ({
    name,
    isActive,
    color = '#6c757d',
    isTrial,
    isPastDue,
    trialLabel,
}) => {
    return (
        <div
            className="d-flex align-items-center px-2 px-md-3 py-2 rounded-pill"
            style={{
                border: `1px solid ${color}`,
                color: color,
                fontWeight: 500,
                background: 'transparent',
            }}
        >
            <span>{name}</span>

            {(isActive || isTrial || isPastDue) && <span className="mx-2">|</span>}

            {isTrial ? (
                <span>{trialLabel}</span>
            ) : (
                (isActive || isPastDue) && (
                    <span className="d-flex align-items-center">
                        {isActive ?? isPastDue}
                        <span
                            className="ml-2 rounded-circle"
                            style={{
                                width: 8,
                                height: 8,
                                backgroundColor: color,
                            }}
                        />
                    </span>
                )
            )}
        </div>
    );
};

export default SubscriptionPlanBadge;
